import { Button, Card, Col, Form, Input, Modal, Row, Select } from 'antd';
import { ResponseDataType, deleteRequest, getRequest, postRequest, patchRequest } from 'api';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PermIdentityOutlined from '@mui/icons-material/PermIdentityOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import styles from './info.module.css';
import { CustomerDataType } from 'Pages/Account/List/Tabs';
import { StringLiteral } from 'typescript';

const { Option } = Select;


interface TeacherInfoType {
  teacherId: number;
  customerId: number;
  gender: number;
  fullName: string | null;
  dob: string | null;
  phoneNumber: string | null;
  email: string | null;
  address: string | null;
  currentStatus: number;
  contractType: number;
  schoolId: number;
}

interface ClassInfoType {
  classLevel: string;
  className: string;
  schoolId: number;
  classOrder: number;
  // description: string | null;
  startYear: number;
  endYear: number;
  teacherDTO: TeacherInfoType;
}
// interface FormValueType {
//   classLevel: number;
//   className: string;
//   schoolId: number;
//   classOrder: number;
//   description: string | null;
// }

interface FormValueType {
  classId: number;
  teacherId: number;
}
export const ClassInfo = ({ classId: propClassId }: { classId?: string | number }) => {
  const schoolId = localStorage.getItem('schoolId');
  const { classId: paramClassId } = useParams();
  const classId = propClassId || paramClassId;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [classInfo, setClassInfo] = useState<ClassInfoType>();
  const [teacherList, setTeacherList] = useState<TeacherInfoType[]>([]);
  const [teacherId, setTeacherId] = useState<number | undefined>();
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  // const [teacherInfo, setTeacherInfo] = useState<TeacherInfoType | undefined>();

  useEffect(() => {
    const GetClassInfo = async () => {
      const response: ResponseDataType<ClassInfoType> = await getRequest(
        `/cms/class/get-class-info?classId=${classId}`
      );
      // console.log('response', response);
      if (response.code === 200) {
        setClassInfo(response.info);
      } else {
        toast.error(response.msg);
        // navigate('/class-list');
      }
    };
    GetClassInfo();
  }, [classId, navigate]);

  const UpdateClassInfo = () => {
    if (teacherId) {
      Modal.confirm({
        style: { fontFamily: 'Quicksand' },
        title: 'Xác nhận thêm GVCN?',
        async onOk() {
          // const teacherInfo: TeacherInfoType | undefined = await getTeacherInfo();
          // console.log(teacherInfo);
          const response: ResponseDataType<ClassInfoType> = await postRequest(
            `/cms/class/add-teacher-to-class?classId=${classId}&teacherId=${teacherId}`
          );
          console.log('response', response);
          if (response) {
            if (response.code === 200) {
              toast.success('Thêm GVCN thành công!');
              window.location.reload();
            } else {
              toast.error('Thêm GVCN thất bại!');
              // Change tab in case of error
            }
          } else {
            toast.error('Thêm GVCN thất bại!');
          }
        },
      });
    } else {
      toast.error('Bạn cần chọn giáo viên chủ nhiệm!');
    }
  };

  const handleOpenPopup = () => {
    setOpenPopup(true);
    const GetTeacherList = async () => {
      const response: ResponseDataType<TeacherInfoType[]> = await getRequest(
        `/cms/teacher/get-teacher-by-school?schoolId=${schoolId}`
      );
      if (response) {
        if (response.code === 200) {
          setTeacherList(response.info || []);
        } else {
          console.log(response.msg);
        }
      }
    };
    GetTeacherList();
  }

  const handleClosePopup = () => {
    setOpenPopup(false);
    setTeacherId(undefined);
  }
  // const UpdateClassInfo = (value: FormValueType) => {
  //   // console.log('value', value);
  //   const formData = {
  //     "classId": classInfo.classId,
  //     "classLevel": value.classLevel,
  //     "className": value.className,
  //     "schoolId": schoolId,
  //     "classOrder": value.classOrder,
  //     "description": value.description,
  //   };
  //   console.log('formData', formData);


  //   Modal.confirm({
  //     style: { fontFamily: 'Quicksand' },
  //     title: 'Xác nhận cập nhật thông tin lớp học?',
  //     async onOk() {
  //       const response: ResponseDataType<ClassInfoType> = await patchRequest(
  //         '/cms/class/create-class',
  //         formData,
  //         'json'
  //       );
  //       console.log('response', response);
  //       if (response) {
  //         if (response.code === 200) {
  //           toast.success('Cập nhật thông tin lớp thành công!');
  //           navigate('/class-list');
  //         } else {
  //           toast.error('Cập nhật thông tin lớp thất bại!');
  //           // Change tab in case of error
  //         }
  //       } else {
  //         toast.error('Cập nhật thông tin lớp thất bại!');
  //       }
  //     },
  //   });
  // };

  // const DeleteCustomer = () => {
  //   Modal.confirm({
  //     style: { fontFamily: 'Quicksand' },
  //     title: 'Xác nhận xóa tài khoản?',
  //     async onOk() {
  //       const response: ResponseDataType<string> = await deleteRequest(
  //         `/cms/customer/${accountId}`
  //       );
  //       console.log('response', response);
  //       if (response) {
  //         if (response.code === 200) {
  //           toast.success('Xóa tài khoản thành công!');
  //           navigate('/account-list');
  //         } else {
  //           toast.error('Xóa tài khoản thất bại!');
  //           // Change tab in case of error
  //         }
  //       } else {
  //         toast.error('Xóa tài khoản thất bại!');
  //       }
  //     },
  //   });
  // };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      <Card title='Thông tin lớp học' className={styles.class_info_card}>
        <Form form={form}>
          <Row>
            <Col span={6}>
              <div
                className={styles.card_content_label}
                style={{ marginTop: 0 }}
              >
                &nbsp;&nbsp;Khối:
              </div>
            </Col>
            <Col span={18}>
              <div
                className={styles.card_content_label_content}
                style={{ marginTop: -4 }}
              >
                <Form.Item name='classLevel'>
                  {classInfo?.classLevel}
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <div
                className={styles.card_content_label}
                style={{ marginTop: 0 }}
              >
                &nbsp;&nbsp;Tên lớp:
              </div>
            </Col>
            <Col span={18}>
              <div
                className={styles.card_content_label_content}
                style={{ marginTop: -4 }}
              >
                <Form.Item name='className'>
                  {classInfo?.className}
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <div
                className={styles.card_content_label}
                style={{ marginTop: 0 }}
              >
                &nbsp;&nbsp;Class Order:
              </div>
            </Col>
            <Col span={18}>
              <div
                className={styles.card_content_label_content}
                style={{ marginTop: -4 }}
              >
                <Form.Item name='classOrder'>
                  {classInfo?.classOrder}
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <div
                className={styles.card_content_label}
                style={{ marginTop: 0 }}
              >
                &nbsp;&nbsp;Năm bắt đầu:
              </div>
            </Col>
            <Col span={18}>
              <div
                className={styles.card_content_label_content}
                style={{ marginTop: -4 }}
              >
                <Form.Item name='startYear'>
                  {classInfo?.startYear}
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <div
                className={styles.card_content_label}
                style={{ marginTop: 0 }}
              >
                &nbsp;&nbsp;Hoàn thành:
              </div>
            </Col>
            <Col span={18}>
              <div
                className={styles.card_content_label_content}
                style={{ marginTop: -4 }}
              >
                <Form.Item name='endYear'>
                  {classInfo?.endYear}
                </Form.Item>
              </div>
            </Col>
          </Row>
          {/* {!classInfo?.teacherDTO && (
            <Button type='primary' onClick={() => handleOpenPopup()}>
              Thêm GVCN
            </Button>
          )} */}
        </Form>
      </Card>
      {classInfo?.teacherDTO &&
        (
          <Card title='Giáo viên chủ nhiệm' className={styles.teacher_info_card}>
            <Form>
              <Row>
                <Col span={6}>
                  <div
                    className={styles.card_content_label}
                    style={{ marginTop: 0 }}
                  >
                    &nbsp;&nbsp;Tên:
                  </div>
                </Col>
                <Col span={18}>
                  <div
                    className={styles.card_content_label_content}
                    style={{ marginTop: -4 }}
                  >
                    <Form.Item>
                      {classInfo?.teacherDTO.fullName}
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <div
                    className={styles.card_content_label}
                    style={{ marginTop: 0 }}
                  >
                    &nbsp;&nbsp;Email:
                  </div>
                </Col>
                <Col span={18}>
                  <div
                    className={styles.card_content_label_content}
                    style={{ marginTop: -4 }}
                  >
                    <Form.Item>
                      {classInfo?.teacherDTO.email}
                    </Form.Item>
                  </div>
                </Col>
              </Row>
            </Form>
          </Card>
        )
      }
      <Modal
        title='Thêm GVCN'
        centered
        visible={openPopup}
        onCancel={handleClosePopup}
        footer={[
          <Button key='cancel' onClick={() => handleClosePopup()}>Hủy</Button>,
          <Button key='submit' type='primary' onClick={() => UpdateClassInfo()}>Thêm GVCN</Button>
        ]}>
        <Row style={{ marginTop: 20 }}>
          <Col span={6}>
            <div className={styles.card_content_label}>
              <PermIdentityOutlined />
              &nbsp;&nbsp;GVCN:
            </div>
          </Col>
          <Col span={18}>
            <Select
              showSearch
              value={teacherId}
              onChange={(value) => setTeacherId(value)}
              style={{ 'width': '100%', marginRight: 8 }}
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (option?.children) {
                  return (
                    option.children.toString()
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                } else {
                  return true;
                }
              }}
            >
              {teacherList.map((teacher) => (
                <Option key={teacher.teacherId} value={teacher.teacherId}>
                  {teacher.email}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
      </Modal>
    </div >
  );
};
